import React, { useState } from 'react';
import { IconButton, Tooltip, Menu, MenuItem } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { useRecoilValue } from 'recoil';
import { userState } from '../../../atoms/States';
import HolidaySettingsModal from './HolidaySettings';
import AutoForecastSettingsModal from './AutoForecastSettings';

const SETTINGS_MENU_ITEMS = [
  {
    key: 'holiday',
    label: 'Holiday Settings',
  },
  {
    key: 'auto-forecast',
    label: 'Auto Forecast Settings',
    // scopes: ['super-admin', 'admin'],
    getDisabledReason: ({ forecasts = [] }) => (forecasts.length === 0 ? 'No forecast data' : null),
  },
];

// itemProps: { [item.key]: props } - each item's disabled check and modal read only their own entry
const Settings = ({ itemProps = {} }) => {
  const user = useRecoilValue(userState);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openedItemKey, setOpenedItemKey] = useState(null);

  const userScopes = user?.scopes ?? user?.user?.scopes ?? [];

  const getDisabledReason = (item) => {
    if (item.scopes && !item.scopes.some((scope) => userScopes.includes(scope))) {
      return `You don't have permission`;
    }
    return item.getDisabledReason?.(itemProps[item.key] ?? {}) || null;
  };

  const onClickItem = (item) => {
    setAnchorEl(null);
    setOpenedItemKey(item.key);
  };

  const closeModal = () => setOpenedItemKey(null);

  return (
    <>
      <Tooltip title="Settings">
        <IconButton aria-label="forecast-settings" onClick={(event) => setAnchorEl(event.currentTarget)} size="small">
          <SettingsIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
        {SETTINGS_MENU_ITEMS.map((item) => {
          const disabledReason = getDisabledReason(item);
          const menuItem = (
            <MenuItem key={item.key} disabled={Boolean(disabledReason)} onClick={() => onClickItem(item)}>
              {item.label}
            </MenuItem>
          );
          if (!disabledReason) {
            return menuItem;
          }
          // Disabled MenuItem ignores pointer events, the span lets the tooltip fire
          return (
            <Tooltip key={item.key} title={disabledReason} placement="left">
              <span>{menuItem}</span>
            </Tooltip>
          );
        })}
      </Menu>
      <HolidaySettingsModal open={openedItemKey === 'holiday'} onClose={closeModal} />
      <AutoForecastSettingsModal open={openedItemKey === 'auto-forecast'} onClose={closeModal} {...itemProps['auto-forecast']} />
    </>
  );
};

export default Settings;
